import { Dialog, Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
  isOpen: boolean;
  titleKey?: string;
  messageKey?: string;
  confirmKey?: string;
  cancelKey?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  isOpen,
  titleKey = 'sidebar.confirmDelete.title',
  messageKey = 'sidebar.confirmDelete.message',
  confirmKey = 'sidebar.confirmDelete.confirm',
  cancelKey = 'sidebar.confirmDelete.cancel',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => !e.open && onCancel()} placement="center">
      <Dialog.Backdrop bg="blackAlpha.600" />
      <Dialog.Positioner>
        <Dialog.Content borderRadius="2xl" boxShadow="xl" mx={4} maxW="md">
          <Dialog.Header borderBottom="1px solid" borderColor="gray.200" px={6} py={4}>
            <Dialog.Title fontSize="lg" fontWeight="semibold" color="gray.900">
              {t(titleKey)}
            </Dialog.Title>
          </Dialog.Header>
          {t(messageKey) && (
            <Dialog.Body px={6} py={4}>
              <Text m={0} fontSize="sm" lineHeight="1.6" color="gray.600">
                {t(messageKey)}
              </Text>
            </Dialog.Body>
          )}
          <Dialog.Footer gap={3} px={6} py={4} justifyContent="flex-end">
            <Button variant="secondary" size="md" onClick={onCancel}>
              {t(cancelKey)}
            </Button>
            <Button variant="error" size="md" onClick={onConfirm}>
              {t(confirmKey)}
            </Button>
          </Dialog.Footer>
          <Dialog.CloseTrigger />
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
